var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{attrs:{"colspan":"1"}},_vm._l((_vm.sheme.reduce(
  function (rv,e){ 
    (rv[e.shema]=rv[e.shema]||[]).push(e.sezona);
     return rv;},{})),function(leta,shema){return _c('button',{staticClass:"k-button k-primary k-mr-1"},[_vm._v(" "+_vm._s(shema)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }